var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"reveal",rawName:"v-reveal"}],staticClass:"section-title"},[_c('div',{staticClass:"section-title__eyebrow"},[_vm._v(_vm._s(_vm.$pick(_vm.eyebrow)))]),_c('h2',[_vm._v(_vm._s(_vm.$pick(_vm.title)))]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.$pick(_vm.description)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }